module.exports = __webpack_public_path__ + "static/media/sites.f9054d77.jpg";